import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useInstance} from 'react-ioc';
import {useNavigate} from 'react-router-dom';
import {LeftOutlined} from '@ant-design/icons';
import {useLazyQuery} from '@apollo/client';
import {Button, Skeleton} from 'antd';

import {Header} from '../../components/Header/Header';
import Layout from '../../components/Layout/Layout';
import {INDEX} from '../../config/routes';
import {Store} from '../../model/store/Store';
import {step} from '../../shared/graphql/__generated__/step';
import { QUERY_STEP} from '../../shared/graphql/anket';

import {Step} from './Step';


export const Application = () => {

    const [loading, setLoading] = useState(true);
    const [update, setUpdate] = useState<boolean>(false);
    const [step, setStep] = useState<number|undefined>(undefined);
    const {auth} = useInstance(Store)
    const {t} = useTranslation()
    const navigate = useNavigate()
    const [query] = useLazyQuery<step>(QUERY_STEP, {
        onCompleted: (data) => {
            if (data.step.step === -1) {
                auth.needUpdate()
                navigate(INDEX)
            } else {
                setStep(data.step.step!)
            }
            setLoading(false);
        }
    });

    useEffect(() => {
        query()
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (update) {
            setLoading(true);
            query()
            setUpdate(false);
        }
    }, [update, setUpdate, query])

    console.log('step', step);
    
    return (
        <Layout header={<Header title={t('Extended application')} left={<Button onClick={() => navigate(-1)} size={'small'} shape={'circle'} type={'link'} icon={<LeftOutlined/>}/>}/>} >
            {loading && <Skeleton active={true}/>}
            {!loading && step !== undefined && <Step defaultStep={step || 0} onUpdate={() => setUpdate(true)}/>}
        </Layout>

    )

}